import { Alert } from '@mui/material';

export const SUPPORTED_RICH_TEXT_FEATURES = {
  br: <br />,
  em: (parts: any) => <em>{parts}</em>,
  info: (parts: any) => <Alert severity="info">{parts}</Alert>,
  strong: (parts: any) => <strong>{parts}</strong>,
};
const [br, em, info, strong] = Object.keys(SUPPORTED_RICH_TEXT_FEATURES);

export const SUPPORTED_RICH_TEXT_FEATURES_LABELS = {
  [br]: 'Line break: {br}',
  [em]: 'Italic: <em>*text*</em>',
  [info]: 'Info Alert: <info>*text*</info>',
  [strong]: 'Bold: <strong>*text*</strong>',
};
